import posthog from 'posthog-js';

try {
    if (!process.env.REACT_APP_PUBLIC_POSTHOG_KEY || !process.env.REACT_APP_PUBLIC_POSTHOG_HOST) {
        console.warn('PostHog is not configured. Skipping initialization.');
    } else {
        posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
            api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
            autocapture: false,
            capture_pageview: true,
        });
    }
} catch (error) {
    console.error('Error initializing PostHog: ', error);
}
export default posthog;
